import * as braze from "@braze/web-sdk";
import {CustomAttributes} from './interface'
const DEFINITION = "fz_unique_braze_id"
import { v4 as uuidv4 } from 'uuid';
import { BRAZE_API_KEY } from "../../config/webpack/constants/envrionment";

export const TRACKING_PROPERTY = {utm_campaign: 'utm_campaign', utm_content: 'utm_content'}

const FzBraze = class {
    constructor(brazeApiKey = BRAZE_API_KEY, baseUrl = `sdk.fra-01.braze.eu`) { // For now hardcode the braze apiKey and endpoint, this is public information anyways.
        this.generateDefintionCookieIfNotExists()
        braze.initialize(brazeApiKey, {
            baseUrl
        });

    }
    defineNewUser() {
        const id = this.getUniqeId()
        //braze.changeUser(id)
        //braze.getUser()?.setCustomUserAttribute("external_id", `${id}`)
        braze.getUser()?.setCustomUserAttribute("external_id", `${id}`)
        braze.changeUser(id)

    }
    static commitUser(email:string, accountId:string) {
        if(braze.getUser()?.setEmail(email)) {
            //braze.getUser()?.setCustomUserAttribute("external_id", accountId)
            braze.getUser()?.setCustomUserAttribute("account_id", accountId)
            //braze.changeUser(accountId)
        }
    }
    static changeUser(brazeId: string) {
        return braze.changeUser(brazeId)
    }
    setCustomAttributes(attributes: CustomAttributes) {
        attributes.forEach((attribute: any) => {
            for (const key in attribute) {
                braze.getUser()?.setCustomUserAttribute(key, `${attribute[key]}`)
            }
        })
    }
    removeCustomAttributes(attributes: Array<string>) {
        attributes.forEach((attribute) => {
            braze.getUser()?.setCustomUserAttribute(attribute, null)
        })
    }
    getUser() {
        return braze.getUser()
    }
    setEmail(email: string) {
      return braze.getUser()?.setEmail(email)
    }
    getUniqeId() {
        return this.definitionCookie() || uuidv4()

    }
    generateDefintionCookieIfNotExists() {
        const uniqueId = this.getUniqeId();
        const hostName = String(window.location.hostname)
        const topDomain = hostName.split('.').splice(-2).join('.')
        if (!this.definitionCookie())
        // eslint-disable-next-line
            document.cookie = DEFINITION +"=" + uniqueId + ";expires="+"Fri, 31 Dec 9999 23:59:59 GMT"
                    + `;domain=.${topDomain};path=/`;
    }
    definitionCookie() {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${DEFINITION}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();

    }
 }

export default FzBraze
